import { useMutation, useQuery } from "@tanstack/react-query"
import {
  abandonDraft,
  getIssue,
  listDrafts,
  uploadAttachment,
} from "../api/assistant-api"

export function useAbandonDraft() {
  return useMutation({
    mutationFn: (id: number) => abandonDraft(id),
  })
}

/**
 * Stable mutation key for chat-attachment uploads. Submit buttons use
 * ``useIsMutating({ mutationKey: UPLOAD_ATTACHMENT_MUTATION_KEY })`` to
 * detect in-flight uploads and block final submission until they
 * finish — otherwise a click before the upload resolves can file the
 * issue without the file (and orphan it server-side).
 */
export const UPLOAD_ATTACHMENT_MUTATION_KEY = ["upload-attachment"] as const

export function useUploadChatAttachment() {
  return useMutation({
    mutationKey: [...UPLOAD_ATTACHMENT_MUTATION_KEY],
    mutationFn: (file: File) => uploadAttachment(file),
  })
}

export function useThreadList(enabled = true) {
  // Keep the old query key so anything that invalidates ["chat-threads"]
  // continues to refresh this data.
  return useQuery({
    queryKey: ["chat-threads"],
    queryFn: listDrafts,
    enabled,
  })
}

export function useThread(id: number | null) {
  return useQuery({
    queryKey: ["chat-thread", id],
    queryFn: () => getIssue(id as number),
    enabled: id != null && id > 0,
  })
}
